import * as TYPES from '../types';

export const getAllCollaborationAction = () => {
    return {
        type: TYPES.GET_ALL_COLLABORATION,
    };
};

export const getAllCollaborationSuccessAction = (payload) => {
    return {
        type: TYPES.GET_ALL_COLLABORATION_SUCCESS,
        payload: payload
    };
};